import React from 'react'
import { mdiAlert } from '@mdi/js'

import { ClaimDeviceH4 } from '../styles'
import {
  ClaimDeviceErrorContainer,
  ClaimDeviceErrorDescription,
  ClaimDeviceErrorIcon,
  ClaimDeviceErrorRetryButton,
  ClaimDeviceErrorSpan,
} from './styles'

interface QrCodeScanNotAllowedErrorProps {
  onEraseDataClick: () => void
}

// TODO: Localize
function QrCodeScanNotAllowedError({
  onEraseDataClick,
}: QrCodeScanNotAllowedErrorProps) {
  return (
    <ClaimDeviceErrorContainer>
      <ClaimDeviceErrorIcon path={mdiAlert} size={2} />
      <ClaimDeviceH4>Error</ClaimDeviceH4>
      <ClaimDeviceErrorDescription>
        <ClaimDeviceErrorSpan>
          Enable camera access in browser and retry or switch to manual
          claiming.
        </ClaimDeviceErrorSpan>
      </ClaimDeviceErrorDescription>
      <ClaimDeviceErrorRetryButton
        variant="primary"
        type="button"
        onClick={onEraseDataClick}
      >
        Retry
      </ClaimDeviceErrorRetryButton>
    </ClaimDeviceErrorContainer>
  )
}

export default QrCodeScanNotAllowedError
